import { t } from "@web-monorepo/i18n/macro";
import { LOGO_CDN_URLS } from "./urls";
import classes from "./DDSLogo.module.css";

export type DDSLogoBrand = "classdojo" | "dojo-tutor" | "dojo-sparks" | "dojo-islands";
export type DDSLogoVariant = "lockup" | "mark";
export type DDSLogoSize = "sm" | "md" | "lg" | "xl";

type DDSLogoProps = {
  brand: DDSLogoBrand;
  variant?: DDSLogoVariant;
  size?: DDSLogoSize;
  className?: string;
  "data-name"?: string;
};

const BRAND_LABELS: Record<DDSLogoBrand, () => string> = {
  classdojo: () => t`ClassDojo logo`,
  "dojo-tutor": () => t`Dojo Tutor logo`,
  "dojo-sparks": () => t`Dojo Sparks logo`,
  "dojo-islands": () => t`Dojo Islands logo`,
};

export const DDSLogo = ({ brand, variant = "lockup", size = "md", className, "data-name": dataName }: DDSLogoProps) => {
  const sizeClass = classes[size];
  return (
    <img
      src={LOGO_CDN_URLS[brand][variant]}
      alt={BRAND_LABELS[brand]()}
      className={className ? `${sizeClass} ${className}` : sizeClass}
      data-name={dataName}
    />
  );
};
